@custom-media --tablet (max-width: 1024px);

.surveyContainer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  & > article {
    flex-basis: 32%;
    margin-bottom: 2rem;

    @media (--tablet) {
      flex-basis: 100%;
    }
  }
}

.buttonContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

.surveyBoxButton {
  width: fit-content;
  display: inline-block;
}

.showMoreButton {
  border: 0;
  padding: 0;
  background-color: unset;
  color: var(--blue);
  margin-bottom: 3rem;
}
